import { ENDPOINTS } from '../utils/endpoints';
import { getAPIwithToken, postAPIwithToken, putAPIwithToken } from '../utils/fetchApi';

export interface DistributorFiltersPayload {
  name?: string;
  phone?: string;
  search?: string;
  zoneName?: string;
  territoryName?: string;
  cityName?: string;
  depo?: string;
  route?: string;
  status?: number | string;
  page?: number;
  limit?: number;
}

export const getDistributorsAPI = async (_filters: DistributorFiltersPayload = {}) => {
  return await getAPIwithToken(ENDPOINTS.GET_DISTRIBUTORS);
};

export const getDistributorByIdAPI = async (id: number | string) => {
  try {
    return await getAPIwithToken(ENDPOINTS.GET_DISTRIBUTOR_BY_ID(id));
  } catch {
    // Fallback attempt without /api/v1 prefix if first attempt fails
    return await getAPIwithToken(`erp/distributor/${id}`);
  }
};

export const createDistributorAPI = async (data: Record<string, any>) => {
  return await postAPIwithToken(ENDPOINTS.CREATE_DISTRIBUTOR, data);
};

export const updateDistributorAPI = async (id: number | string, data: Record<string, any>) => {
  return await putAPIwithToken(ENDPOINTS.UPDATE_DISTRIBUTOR(id), data);
};


